export const ERRORS = Object.freeze({
    SECTION: {
        EMPTY_FIELD_WHEN_ACTIVE: 'SWAG_SCROLL_NAVIGATION_EMPTY_FIELD_WHEN_ACTIVE_ERROR',
        FIELD_TOO_LONG: 'SWAG_SCROLL_NAVIGATION_FIELD_TOO_LONG_ERROR',
        DUPLICATE_VALUE: 'SWAG_SCROLL_NAVIGATION_DUPLICATE_VALUE_ERROR',
    },
});

export default {
    ERRORS,
};
